import { ROUTE_DASHBOARD_ROOT } from "./app-constants";
import replaceParams from "./replace-params";

export default function getDashboardRoute(
  params: Record<string, string | number>,
  ...routes: string[]
) {
  let path = [ROUTE_DASHBOARD_ROOT, ...routes].join("/");
  if (params) {
    path = replaceParams(path, params);
  }
  return `/${path}`;
}
